import { useModalContentToggler } from '@components'

import { Button, Flex, notify, Spacing } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { NotificationKeys } from '../../../../../../../../../../enums/notificationKeys'
import { useCustomerForm } from '../../../../../../contexts/customerFormContext'

export const AddContactPersonModalFooter = (): ReactElement => {
  const { t } = useTranslation()
  const { addContactPerson, isLoading, isSubmitting } = useCustomerForm()
  const { prevState, setActiveState } = useModalContentToggler()

  const handleSaveButtonClick = useCallback(() => {
    const wasContactPersonAdded = addContactPerson()

    if (!wasContactPersonAdded) {
      notify({
        id: NotificationKeys.MultipleContacts,
        message: t('customer_modal.add_contact.error_message'),
        variant: 'error',
      })
      return
    }

    notify({
      id: NotificationKeys.MultipleContacts,
      message: t('customer_modal.add_contact.label'),
      variant: 'success',
    })

    setActiveState(prevState)
  }, [addContactPerson, prevState, setActiveState, t])

  const handleBackButtonClick = useCallback(() => {
    setActiveState(prevState)
  }, [prevState, setActiveState])

  return (
    <Flex justifyContent="flex-end" width="100%" gap={Spacing.S8}>
      <Button variant="outlined" disabled={isLoading || isSubmitting} onClick={handleBackButtonClick}>
        {t('back')}
      </Button>
      <Button disabled={isLoading || isSubmitting} loading={isSubmitting} onClick={handleSaveButtonClick}>
        {t('customer_modal.form.company_persons.modal.add_button.label')}
      </Button>
    </Flex>
  )
}
